export default "__VITE_ASSET__be3a5ebf__"